<template>
  <div class="cv-content">
    <el-form :rules="rules" ref="dataForm" v-loading="loading" :model="resumeInfo" label-width="100px"
      label-position="right">
      <h3>基本信息</h3>
      <div class="section1">
        <el-row>
          <el-col :span='12'>
            <el-form-item label="姓名：" prop="user_infokey.FullName">
              <el-tooltip class="item" effect="dark" :disabled="!fullNameAllowEdit" content="购买过会员套餐的人才不支持修改姓名，如需修改请联系职业顾问" placement="top-start">
                <el-input v-model="resumeInfo.user_infokey.FullName" :disabled="fullNameAllowEdit" placeholder='请填写'>
                </el-input>
              </el-tooltip>
            </el-form-item>
            <el-form-item label="性别：" prop="basic_info.SexID">
              <el-select v-model="resumeInfo.basic_info.SexID" placeholder='请选择' style="width:100%;"
                @change="onSexChange">
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="2"></el-option>
                <el-option label="保密" :value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="出生日期：" prop="basic_info.Birthday">
              <el-date-picker v-model="resumeInfo.basic_info.Birthday" type="date" default-value="1990-1-1"
                placeholder='请选择' format="yyyy/MM/dd" value-format="yyyy-MM-dd" style="width:100%;"></el-date-picker>
            </el-form-item>
            <el-form-item label="户籍：" prop="">
              <el-cascader class="width_full" v-model="resumeInfo.basic_info.NativeCityID" :options="twoLevelCitys"
                @change="onNativeCityChange"></el-cascader>
            </el-form-item>
            <el-form-item label="居住地：" prop="">
              <el-cascader class="width_full" v-model="resumeInfo.basic_info.LiveCityID" :options="citys"
                @change="onLiveCityChange">
              </el-cascader>
            </el-form-item>
            <el-form-item label="手机：" prop="user_data.Mobile">
              <span>{{resumeInfo.user_data.Mobile}}</span>
              <el-link :underline="false" style="margin-left:10px;" @click="mobileVerifyVisible = true">修改</el-link>
              <el-popover title="修改手机" width="360" trigger="manual" v-model="mobileVerifyVisible">
                <div>
                  <el-row style="margin: 6px 0; line-height:40px;">
                    <el-col :span="6">新手机</el-col>
                    <el-col :span="18">
                      <el-input v-model="newMobile" placeholder="新的手机号码">
                        <template slot="append">
                          <el-button slot="reference" size="small" :disabled="mobileVerifyDisabled"
                            @click="getMobileVerifyCode">
                            {{mobileVerifyText}}</el-button>
                        </template>
                      </el-input>
                    </el-col>
                  </el-row>
                  <el-row style="margin: 6px 0; line-height:40px;">
                    <el-col :span="6">验证码</el-col>
                    <el-col :span="18">
                      <el-input v-model="mobileVerifyCode" placeholder="6 位数字"></el-input>
                    </el-col>
                  </el-row>
                  <div style="text-align: right; margin: 8px 0 0 0;">
                    <el-button size="mini" type="text" @click="mobileVerifyVisible = false">取消</el-button>
                    <el-button type="primary" size="mini" @click="onChangeMobile">确定</el-button>
                  </div>
                </div>
              </el-popover>
            </el-form-item>
            <el-form-item label="工作年限：" prop="">
              <el-input v-model="resumeInfo.basic_info.WorkYear" placeholder='请选择'>
                <template slot="append">年</template>
              </el-input>
            </el-form-item>
            <el-form-item label="体重：" prop="">
              <el-input v-model="resumeInfo.basic_info.Weight" placeholder='请填写'>
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span='12'>
            <el-upload class="upload-demo imgcenter" :action="action" :show-file-list="false"
              :before-upload="uploadPhoto" accept="image/jpeg, image/png">
              <div class="useravatar-shadow-container" @mouseenter="showShadow=true" @mouseleave="showShadow=false">
                <user-avatar :src="resumeInfo.user_data.Logo" class="useravatar-middle"></user-avatar>
                <img v-show="showShadow" src="../assets/images/shadow_tx.png" class="shadow-useravatar-big" />
              </div>
              <div style="text-align:center;margin-top:6px;">
                <el-link type="primary" @click="onDeleteHeadImage">删除</el-link>
                <el-link slot="trigger" type="primary">更换</el-link>
              </div>
            </el-upload>
            <el-form-item label="婚姻状况：" prop="">
              <el-select v-model="resumeInfo.basic_info.MarriedStatusID" placeholder='请选择' style="width:100%;">
                <el-option label="未婚" :value="8"></el-option>
                <el-option label="已婚" :value="9"></el-option>
                <el-option label="离异" :value="10"></el-option>
                <el-option label="保密" :value="87"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="详细地址：" prop="">
              <el-input v-model="resumeInfo.basic_info.LiveAddress" placeholder='请填写'>
              </el-input>
            </el-form-item>
            <el-form-item label="邮箱：">
              <el-input v-model="resumeInfo.user_data.Email">
              </el-input>
            </el-form-item>
            <el-form-item label="身高：" prop="">
              <el-input v-model="resumeInfo.basic_info.Height" placeholder='请填写'>
                <template slot="append">cm</template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>

      <!-- 求职意向 -->
      <h3>求职意向</h3>
      <div class="section1">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="意向城市：">
              <el-select v-model="resumeInfo.expect_city.CityID" multiple placeholder="请选择（可多选）" style="width:100%;">
                <el-option v-for="item in cityOption" :key="item.id" :label="item.city" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作性质：" prop="UserName">
              <el-select v-model="resumeInfo.expect_jobnature.JobNatureID" placeholder='请选择' style="width:100%;">
                <el-option label="全职" :value="11"></el-option>
                <el-option label="兼职" :value="12"></el-option>
                <el-option label="实习" :value="13"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-form-item label="意向职能：" prop="exceptPositionIDs">
            <el-cascader v-model="exceptPositionIDs" :options="positions" :props="positionProps"
              :show-all-levels="false" placeholder="请选择（可多选）" style="width:100%;" @change="onPositionChange">
            </el-cascader>
          </el-form-item>
        </el-row>

        <el-form-item label="期望月薪：" prop="min_salary">
          <el-row>
            <el-input v-model="resumeInfo.expect_salary.MinSalary" style="float:left; width:73px"></el-input>
            <span style="float:left; margin:0 10px;">-</span>
            <el-input v-model="resumeInfo.expect_salary.MaxSalary" style="float:left; width:160px"><template
                slot="append">千元/月</template>
            </el-input>
          </el-row>
        </el-form-item>
      </div>
    </el-form>

    <div class="section1">
      <!-- 工作经历 -->
      <div class="section" style="position:relative;">
        <h3>工作经历</h3>
        <el-tooltip content="新增工作经历" placement="top">
          <a @click="addWork = true" class="addicon" style="position:absolute;right:10px;top:20px;height:15px;"></a>
        </el-tooltip>

        <el-divider></el-divider>
        <ul>
          <li v-for="(item,index) in resumeInfo.work_exp" :key="index">
            <!-- <i class="remarksicon2x"></i> -->
            <el-row class="section-row">
              <el-col :span="10">
                {{$Shared.formatDateYearMonth(item.BeginDate)}} - {{$Shared.formatDateYearMonth(item.EndDate)}}
              </el-col>
              <el-col :span="10">
                {{item.CompanyName}}
              </el-col>
              <el-col :span="2">
                <a class="closeicon" @click="workExpDel(index)"></a>
              </el-col>
              <el-col :span="2">
                <a class="editicon2x" @click="workExpEdit(item, index)"></a>
              </el-col>
            </el-row>
            <el-row class="section-row" v-if="item.WorkPosition">
              <span>职位：{{item.WorkPosition}}</span>
              <span style="margin-left:30px;" v-if="item.WorkDepartment">所在部门：{{item.WorkDepartment}}</span>
            </el-row>
            <el-row class="section-row">工作描述：</el-row>
            <el-row class="section-text">
              <p v-html="$Shared.replaceBreakLine(item.Description)"></p>
            </el-row>
          </li>
        </ul>
      </div>

      <!-- 教育经历 -->
      <div class="section" style="position:relative;">
        <h3>教育经历</h3>
        <el-tooltip content="新增教育经历" placement="top">
          <a @click="addEdu = true" class="addicon" style="position:absolute;right:10px;top:20px;height:15px;"></a>
        </el-tooltip>
        <el-divider></el-divider>
        <ul>
          <li v-for="(item,index) in resumeInfo.edu_exp" :key="index">
            <!-- <i class="remarksicon2x"></i> -->
            <el-row class="section-row">
              <el-col :span="10">{{$Shared.formatDateYearMonth(item.BeginDate)}} -
                {{$Shared.formatDateYearMonth(item.EndDate)}}
              </el-col>
              <el-col :span="10">{{item.School}}
              </el-col>
              <el-col :span="2">
                <a class="closeicon" @click="eduExpDel(index)"></a>
              </el-col>
              <el-col :span="2">
                <a class="editicon2x" @click="eduExpEdit(item, index)"></a>
              </el-col>
            </el-row>
            <el-row class="section-row" v-if="item.degree">
              <span>学历：{{item.degree}}</span>
            </el-row>
            <el-row class="section-row" v-if="item.Major">
              <span>专业：{{item.Major}}</span>
            </el-row>
          </li>
        </ul>
      </div>

      <!-- 项目经验 -->
      <div class="section" style="position:relative;">
        <h3>项目经验</h3>
        <el-tooltip content="新增项目经验" placement="top">
          <a @click="addProject = true" class="addicon" style="position:absolute;right:10px;top:20px;height:15px;"></a>
        </el-tooltip>
        <el-divider></el-divider>
        <ul>
          <li v-for="(item,index) in resumeInfo.project_exp" :key="index">
            <!-- <i class="remarksicon2x"></i> -->
            <el-row class="section-row">
              <el-col :span="10">{{$Shared.formatDateYearMonth(item.BeginDate)}} -
                {{$Shared.formatDateYearMonth(item.EndDate)}}
              </el-col>
              <el-col :span="10">{{item.ProjectName}}
              </el-col>
              <el-col :span="2">
                <a class="closeicon" @click="proExpDel(index)"></a>
              </el-col>
              <el-col :span="2">
                <a class="editicon2x" @click="proExpEdit(item, index)"></a>
              </el-col>
            </el-row>
            <el-row class="section-row">项目描述：</el-row>
            <el-row class="section-text">
              <p v-html="$Shared.replaceBreakLine(item.Description)"></p>
            </el-row>
          </li>
        </ul>
      </div>

      <!-- 专业技能 -->
      <div class="section" style="position:relative;">
        <h3>专业技能</h3>
        <el-divider></el-divider>
        <a @click="onEditProfessionalSkill" class="editicon2x"
          style="position:absolute;right:20px;top:20px;height:15px;"></a>
        <div class="section-text">
          <el-row v-for="(item,index) in resumeInfo.MeResumeProfessionalSkillList" :key="index">
            <el-col>{{item.ProfessionalSkillName}}：{{item.SkillLevel}}</el-col>
          </el-row>
        </div>
      </div>

      <!-- 证书 -->
      <div class="section" style="position:relative;">
        <h3>证书</h3>
        <el-divider></el-divider>
        <a @click="onEditCertificate" class="editicon2x" style="position:absolute;right:20px;top:20px;height:15px;"></a>
        <div class="section-text">
          <el-row v-for="(item,index) in resumeInfo.MeResumeCertificateList" :key="index">
            <el-col>{{item.CertificateName}}</el-col>
          </el-row>
        </div>
      </div>

      <!-- 语言能力 -->
      <div class="section" style="position:relative;">
        <h3>语言能力</h3>
        <el-divider></el-divider>
        <a @click="onEditLanguageSkill" class="editicon2x"
          style="position:absolute;right:20px;top:20px;height:15px;"></a>
        <div class="section-text">
          <el-row v-for="(item,index) in resumeInfo.MeResumeLanguageSkillList" :key="index">
            <el-col>{{item.LanguageSkillName}}：{{item.SkillLevel}}</el-col>
          </el-row>
        </div>
      </div>

      <!-- 自我评价 -->
      <div class="section">
        <h3>自我评价</h3>
        <el-divider></el-divider>
        <el-input type="textarea" :rows="5" placeholder='请填写' v-model="resumeInfo.SelfEvaluation"></el-input>
      </div>

      <!-- 附加信息——其他 -->
      <div class="section">
        <h3>附加信息</h3>
        <el-divider></el-divider>
        <el-input type="textarea" :rows="5" placeholder='请填写' v-model="resumeInfo.OtherInfo"></el-input>
      </div>
    </div>

    <eduAdd :visible="addEdu" @visibleChange="eduAddVisibleChange" @change="onEduAdd">
    </eduAdd>
    <eduEdit :data="edu_item" :visible="editEdu" @visibleChange="eduEditVisibleChange" @change="onEduEdit">
    </eduEdit>
    <workAdd :visible="addWork" @visibleChange="workAddVisibleChange" @change="onWorkAdd">
    </workAdd>
    <workEdit :data="work_item" :visible="editWork" @visibleChange="workEditVisibleChange" @change="onWorkEdit">
    </workEdit>
    <projectAdd :visible="addProject" @visibleChange="projectAddVisibleChange" @change="onProjectAdd"></projectAdd>
    <projectEdit :data="project_item" :visible="editProject" @visibleChange="projectEditVisibleChange"
      @change="onProjectEdit"></projectEdit>

    <certificate :data="editCertificateList" :visible="editCertificate" @visibleChange="certificateVisibleChange"
      @change="certificateChange"></certificate>

    <languageSkill :data="editLanguageSkillList" :visible="editLanguageSkill"
      @visibleChange="languageSkillVisibleChange" @change="languageSkillChange"></languageSkill>

    <professionalSkill :data="editProfessionalSkillList" :visible="editProfessionalSkill"
      @visibleChange="professionalSkillVisibleChange" @change="professionalSkillChange"></professionalSkill>

  </div>
</template>


<script>
  import Vue from 'vue';
  import cityList from '~/static/citys';
  import {
    getMeCityList,
    getPositionList
  } from '~/api/common';

  import {
    getMobileVerifyCode,
    changeMobile,
    getEmailVerifyCode,
    changeEmail,
    hasMeRecord
  } from '~/api/user';

  import {
    uploadPhoto,
    addResume,
  } from '~/api/resume';

  import {
    isOneNumberDecimal
  } from '~/utils/validate';

  import userAvatar from '~/components/UserAvatar';

  import eduAdd from './ResumeEduAdd';
  import eduEdit from './ResumeEduEdit';
  import workAdd from './ResumeWorkAdd';
  import workEdit from './ResumeWorkEdit';
  import projectAdd from './ResumeProjectAdd';
  import projectEdit from './ResumeProjectEdit';
  import certificate from './ResumeCertificate';
  import languageSkill from './ResumeLanguageSkill';
  import professionalSkill from './ResumeProfessionalSkill';

  export default {
    props: {
      resumeDom: {}
    },
    components: {
      professionalSkill,
      certificate,
      languageSkill,
      userAvatar,
      eduAdd,
      eduEdit,
      workAdd,
      workEdit,
      projectAdd,
      projectEdit,
    },
    data() {
      const chkMobile = (rule, value, callback) => {
        if (value == '') {
          callback();
          return;
        }
        if (!this.$Shared.isMobile(value)) {
          callback(new Error('请输入正确的手机号码'));
        } else {
          callback();
        }
      };
      const checkSalarys = (rule, value, callback) => {
        if (!(this.resumeInfo.expect_salary.MinSalary > 0 && this.resumeInfo.expect_salary.MaxSalary > 0)) {
          callback(new Error('请输入期望月薪'));
        } else {
          callback();
        }
      };
      return {
        dlgDoWhatVisible: false,
        salarys: [0, 0],
        exceptPositionIDs: [], //期望职位，可多个
        expectCitys: '', //期望城市
        loading: false,
        cityOption: [],
        citys: cityList.data,
        twoLevelCitys: [],
        checkList: [11],
        positions: [],
        positionProps: {
          multiple: true,
          value: 'id',
          label: 'text',
          children: 'child'
        },

        addEdu: false,
        editEdu: false,
        addWork: false,
        editWork: false,
        addProject: false,
        editProject: false,
        editProfessionalSkill: false,
        editCertificate: false,
        editLanguageSkill: false,

        edu_item: {},
        work_item: {},
        project_item: {},
        editProfessionalSkillList: [],
        editCertificateList: [],
        editLanguageSkillList: [],

        newMobile: '',
        fullNameAllowEdit: false,

        resumeInfo: {
          //用户账号表（UserData）
          user_data: {
            UserName: '', //姓名
            Mobile: '', //手机
            Email: '', //邮箱
            Logo: '' //头像
          },
          //用户关键信息表（UserInfoKey）
          user_infokey: {
            Sex: '', //nvarchar(10)	性别
            FullName: '' //nvarchar(16)	真实姓名  由账号本人自己管理的
          },
          //基本信息:MeBasicInfo 其中MeDataID与人才关联(MeData.MeState:-51~-59)-------------------------
          basic_info: {
            MeDataID: 0,
            DegreeID: '', //学历
            SexID: '', //性别
            NativeCityID: 0, //户籍
            LiveCityID: 0, //居住地
            MarriedStatusID: 87, //婚育情况
            Birthday: '', //生日
            WorkYear: 0, //工作年限
            Height: 0, //身高
            Weight: 0, //体重
            LiveAddress: '', //详细地址
            SalaryStructure: '',
          },

          //意向薪资:会员简历求职意向表（MeResumeExpect）
          expect_salary: {
            MinSalary: 0,
            MaxSalary: 0,
            MinYearSalary: 0,
            MaxYearSalary: 0
          },
          //意向工作性质:会员简历意向工作性质表（MeResumeExpectJobNature）
          expect_jobnature: {
            JobNatureID: ''
          },
          //意向职位:会员简历意向职位表（MeResumeExpectPosition）
          expect_post: [
            // {
            //   PositionID: 0
            // }
          ],
          //意向城市:会员简历意向城市表（MeResumeExpectCity）
          expect_city: {
            CityID: 0
          },

          //教育简历：会员简历教育经历（MeResumeEdu）
          edu_exp: [
            // {
            //   BeginDate: "", //	date	开始年月
            //   EndDate: "", //date	结束年月
            //   DegreeID: "", //	int	学历ID
            //   EduModeID: "", //	int	学习形式ID
            //   School: "", //	nvarchar(255)	学校
            //   Major: "", //	nvarchar(255)	专业
            //   Course: "" //	nvarchar(MAX)	主要课程
            // }
          ],
          //工作经历：会员简历工作经历（MeResumeWork）
          work_exp: [
            // {
            //   BeginDate: "", //	date	开始年月
            //   EndDate: "", //	date	结束年月
            //   CompanyName: "", //	nvarchar(255)	公司名称
            //   IndustryID: "", //	int	行业ID
            //   CoEconomyID: "", //	int	企业性质ID
            //   CoSizeID: "", //	int	企业人数ID
            //   WorkDepartment: "", //	nvarchar(255)	所在部门
            //   WorkPosition: "", //	nvarchar(255)	职位
            //   WorkBoss: "", //	nvarchar(255)	汇报对象
            //   WorkStaff: "", //	int	下属人数
            //   Description: "" //	nvarchar(MAX)	职位描述
            // }
          ],
          //项目经验：会员简历项目经验表（MeResumeProject）
          project_exp: [
            // {
            //   ProjectName: "", //	nvarchar(255)	项目名称
            //   BeginDate: "", //	date	开始时间
            //   EndDate: "", //	date	结束时间
            //   CompanyName: "", //	nvarchar(255)	所属公司
            //   Description: "" //	nvarchar(MAX)	项目描述
            // }
          ],

          MeResumeCertificateList: [],
          MeResumeLanguageSkillList: [],
          MeResumeProfessionalSkillList: [],

          SelfEvaluation: '',
          OtherInfo: ''
        },

        showShadow: false,
        // eslint-disable-next-line no-undef
        action: process.env.BASE_API + '/Upload/Index',

        mobileTime: 0,
        mobileVerifyCode: '',
        mobileVerifyDisabled: false,
        mobileVerifyText: '验证',
        mobileVerifyVisible: false,

        emailTime: 0,
        emailVerifyCode: '',
        emailVerifyDisabled: false,
        emailVerifyText: '验证',
        emailVerifyVisible: false,

        rules: {
          'user_infokey.FullName': [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          'basic_info.SexID': [{
            required: true,
            message: '请选择性别',
            trigger: 'change'
          },
          {
            type: 'number',
            min: 1,
            message: '请选择性别',
            trigger: 'blur'
          }
          ],
          'basic_info.NativeCityID': [{
            required: true,
            message: '请选择户籍',
            trigger: 'change'
          }],
          'basic_info.LiveCityID': [{
            required: true,
            message: '请选择居住地址',
            trigger: 'change'
          }],
          'basic_info.MarriedStatusID': [{
            required: true,
            message: '请选择婚育情况',
            trigger: 'change'
          },
          {
            type: 'number',
            min: 1,
            message: '请选择婚育情况',
            trigger: 'blur'
          }
          ],
          'basic_info.Birthday': [{
            required: true,
            message: '请选择出生日期',
            trigger: 'change'
          }],
          'basic_info.WorkYear': [{
            required: true,
            message: '请输入工作年限',
            trigger: 'blur'
          }],
          'user_data.Mobile': [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: chkMobile,
            trigger: 'blur'
          }
          ],
          'basic_info.Height': [{
            validator: isOneNumberDecimal,
            trigger: 'blur'
          }],
          'basic_info.Weight': [{
            validator: isOneNumberDecimal,
            trigger: 'blur'
          }],
          min_salary: [{
            required: true,
            validator: checkSalarys,
            trigger: 'change'
          }],
        },
      };
    },

    created() {
      this.resumeInfo.basic_info.MeDataID = this.meDataId;
      this.hasMeRecord();
    },

    mounted() {
      getMeCityList().then(m => {
        if (m.errcode == 0) {
          this.cityOption = m.data;
        }
      });

      getPositionList().then(m => {
        if (m.errcode == 0) {
          this.positions = m.data;
        }
      });

      var allCity = JSON.parse(JSON.stringify(cityList.data));
      allCity.forEach(province => {
        province.children.forEach(city => {
          city.children = null;
        });
      });
      this.twoLevelCitys = allCity;
    },

    watch: {
      resumeDom: {
        // the callback will be called immediately after the start of the observation
        immediate: true,
        handler(val) {
          this.SetResumeData(val);
        }
      },

      salarys: function () {
        this.resumeInfo.expect_salary.MinSalary = this.salarys[0];
        this.resumeInfo.expect_salary.MaxSalary = this.salarys[1];
      },
      year_salarys: function () {
        this.resumeInfo.expect_salary.MinYearSalary = this.year_salarys[0];
        this.resumeInfo.expect_salary.MaxYearSalary = this.year_salarys[1];
      },
      mobileTime() {
        if (this.mobileTime > 0) {
          this.mobileVerifyText = this.mobileTime + 's';
          this.mobileVerifyDisabled = true;
        } else {
          this.mobileVerifyText = '验证';
          this.mobileVerifyDisabled = false;
        }
      },
      emailTime() {
        if (this.emailTime > 0) {
          this.emailVerifyText = this.emailTime + 's';
          this.emailVerifyDisabled = true;
        } else {
          this.emailVerifyText = '验证';
          this.emailVerifyDisabled = false;
        }
      }
    },

    methods: {
      hasMeRecord() {
        hasMeRecord().then(m => {
          if (m.errcode === 0) {
            var hasRecord = m.data;
            this.fullNameAllowEdit = hasRecord;
          }
        });
      },
      onDoWhatCancel() {
        this.dlgDoWhatVisible = false;
      },
      onDoWhatConfirm() {
        this.dlgDoWhatVisible = false;
        this.clearValidate();
      },

      //专业技能添加与删除
      professionalSkillAdd() {
        this.$refs.professionalSkill.show(
          this.resumeInfo.MeResumeProfessionalSkillList
        );
      },
      //专业技能变化
      onProfessionalSkillChange(value) {
        this.resumeInfo.MeResumeProfessionalSkillList = [];
        value.forEach(el => {
          this.resumeInfo.MeResumeProfessionalSkillList.push(el);
        });
      },

      //证书添加与删除
      certificateAdd() {
        this.$refs.certificate.show(this.resumeInfo.MeResumeCertificateList);
      },
      //证书变化
      onCertificateChange(value) {
        this.resumeInfo.MeResumeCertificateList = [];
        value.forEach(el => {
          this.resumeInfo.MeResumeCertificateList.push(Object.assign({}, el));
        });
      },

      //语言能力添加与删除
      languageSkillAdd() {
        this.$refs.languageSkill.show(this.resumeInfo.MeResumeLanguageSkillList);
      },
      //语言能力变化
      onLanguageSkillChange(value) {
        this.resumeInfo.MeResumeLanguageSkillList = [];
        value.forEach(el => {
          this.resumeInfo.MeResumeLanguageSkillList.push(Object.assign({}, el));
        });
      },

      //表单复位
      clearValidate() {
        this.ClearFormData();
      },
      //清空表单数据
      ClearFormData() {
        this.resumeInfo.user_data.Mobile = '';
        this.resumeInfo.user_data.Email = '';
        this.resumeInfo.user_data.Logo = '';

        this.resumeInfo.user_infokey.FullName = '';
        this.resumeInfo.user_infokey.Sex = '';

        this.resumeInfo.basic_info.LiveCityID = 0;
        this.resumeInfo.basic_info.Birthday = '';
        this.resumeInfo.basic_info.MarriedStatusID = '';
        this.resumeInfo.basic_info.Mobile2 = '';
        this.resumeInfo.basic_info.SexID = '';
        this.resumeInfo.basic_info.Telephone = '';
        this.resumeInfo.basic_info.NativeCityID = 0;
        this.resumeInfo.basic_info.NationalityID = '';
        this.resumeInfo.basic_info.QQ = '';
        this.resumeInfo.basic_info.LiveAddress = '';

        this.resumeInfo.basic_info.WorkYear = '';
        this.resumeInfo.basic_info.Height = 0;
        this.resumeInfo.basic_info.Weight = 0;
        this.resumeInfo.basic_info.SalaryStructure = '';

        this.resumeInfo.expect_salary.MinSalary = 0;
        this.resumeInfo.expect_salary.MaxSalary = 0;
        this.resumeInfo.expect_salary.MinYearSalary = 0;
        this.resumeInfo.expect_salary.MaxYearSalary = 0;

        this.resumeInfo.expect_city.CityID = 0;
        this.resumeInfo.expect_jobnature.JobNatureID = '';
        this.resumeInfo.expect_post = [];
        this.resumeInfo.edu_exp = [];
        this.resumeInfo.work_exp = [];
        this.resumeInfo.project_exp = [];

        this.resumeInfo.MeResumeCertificateList = [];
        this.resumeInfo.MeResumeLanguageSkillList = [];
        this.resumeInfo.MeResumeProfessionalSkillList = [];

        this.resumeInfo.SelfEvaluation = '';
        this.resumeInfo.OtherInfo = '';

        // this.$refs['dataForm'].resetFields();
      },
      SetResumeData(data) {
        // if (this.onMobileCheck(data.Mobile)) {
        //   this.$refs['dataForm'].resetFields();
        // }
        this.resumeInfo.user_data.Mobile = data.Mobile;
        this.resumeInfo.user_data.Email = data.Email;
        this.resumeInfo.user_data.Logo = data.HeadImage;

        this.resumeInfo.user_infokey.FullName = data.FullName;

        if (data.MeBasicInfo) {
          this.resumeInfo.basic_info.LiveCityID = data.MeBasicInfo.LiveCityID;
          this.resumeInfo.basic_info.NativeCityID = data.MeBasicInfo.NativeCityID;
          this.getBirtday(data.MeBasicInfo.Birthday);
          let marid = data.MeBasicInfo.MarriedStatusID;
          this.resumeInfo.basic_info.MarriedStatusID = marid == 0 ? 87 : marid;
          this.resumeInfo.basic_info.Mobile2 = data.MeBasicInfo.Mobile2;
          this.onSexChange(data.MeBasicInfo.SexID);
          this.resumeInfo.basic_info.WorkYear = data.MeBasicInfo.WorkYear;
          this.resumeInfo.basic_info.Height = data.MeBasicInfo.Height;
          this.resumeInfo.basic_info.Weight = data.MeBasicInfo.Weight;
          this.resumeInfo.basic_info.NationalityID = data.MeBasicInfo.NationalityID;
          this.resumeInfo.basic_info.QQ = data.MeBasicInfo.QQ;
          this.resumeInfo.basic_info.Telephone = data.MeBasicInfo.Telephone;
          this.resumeInfo.basic_info.LiveAddress = data.MeBasicInfo.LiveAddress;
          this.resumeInfo.basic_info.SalaryStructure = data.MeBasicInfo.SalaryStructure;
        }

        if (data.MeResumeExpect) {
          let minSalary = Number(data.MeResumeExpect.MinSalary);
          let maxSalary = Number(data.MeResumeExpect.MaxSalary);
          this.resumeInfo.expect_salary.MinSalary = this.salarys[0] = minSalary;
          this.$set(this.salarys, 0, minSalary);

          this.resumeInfo.expect_salary.MaxSalary = this.salarys[1] = maxSalary;
          this.$set(this.salarys, 1, maxSalary);
        }

        if (data.MeResumeExpectCityList) {
          let resumeCitys = data.MeResumeExpectCityList;
          if (resumeCitys[0]) {
            let cityID = Number(resumeCitys[0].CityID);
            this.resumeInfo.expect_city.CityID = isNaN(cityID) ? 0 : cityID;
          }
        }

        let resumeJobnatures = data.MeResumeExpectJobNatureList;
        if (resumeJobnatures && resumeJobnatures.length > 0) {
          this.resumeInfo.expect_jobnature.JobNatureID = resumeJobnatures[0].JobNatureID;
        }

        let resumePosts = data.MeResumeExpectPositionList;
        this.exceptPositionIDs = [];
        if (resumePosts) {
          resumePosts.forEach(item => {
            this.resumeInfo.expect_post.push({
              PositionID: [
                parseInt(item.PositionID / 100) * 100,
                item.PositionID
              ]
            });
            this.exceptPositionIDs.push([
              parseInt(item.PositionID / 100) * 100,
              item.PositionID,
            ]);
          });
        }

        this.resumeInfo.edu_exp = [];
        let eduExpList = data.MeResumeEduList;
        if (eduExpList != null && eduExpList.length > 0) {
          eduExpList.forEach(edu => {
            this.resumeInfo.edu_exp.push(edu);
          });
        }
        this.resumeInfo.work_exp = [];
        let workExpList = data.MeResumeWorkList;
        if (workExpList != null && workExpList.length > 0) {
          workExpList.forEach(workDt => {
            this.resumeInfo.work_exp.push(workDt);
          });
        }

        this.resumeInfo.project_exp = [];
        let proExpList = data.MeResumeProjectList;
        if (proExpList != null && proExpList.length > 0) {
          proExpList.forEach(proDt => {
            this.resumeInfo.project_exp.push(proDt);
          });
        }

        this.resumeInfo.MeResumeCertificateList = data.MeResumeCertificateList;
        this.resumeInfo.MeResumeLanguageSkillList = data.MeResumeLanguageSkillList;
        this.resumeInfo.MeResumeProfessionalSkillList = data.MeResumeProfessionalSkillList;

        if (data.MeResume) {
          this.resumeInfo.SelfEvaluation = data.MeResume.SelfEvaluation;
          this.resumeInfo.OtherInfo = data.MeResume.OtherInfo;
        }
      },

      _SetEndData(endDateList) {
        if (endDateList != null && endDateList.length > 0) {
          endDateList.forEach(el => {
            el.EndDate = el.EndDate == '至今' ? '1900-01' : el.EndDate;
          });
        }
      },
      Edit() {
        if (this.resumeInfo.user_data.Mobile && !this.$Shared.isMobile(this.resumeInfo.user_data.Mobile)) {
          this.$message.error('手机格式不正确，请检查后添加');
          this.$emit('complete', 0);
          return false;
        }
        this.$refs['dataForm'].validate(valid => {
          if (valid) {
            this._SetEndData(this.resumeInfo.work_exp);
            this._SetEndData(this.resumeInfo.edu_exp);
            this._SetEndData(this.resumeInfo.project_exp);
            this.resumeInfo.user_infokey.Sex = Number(this.resumeInfo.user_infokey.Sex);
            this.resumeInfo.basic_info.SexID = Number(this.resumeInfo.basic_info.SexID);
            if (this.resumeInfo.basic_info.Birthday == '') this.resumeInfo.basic_info.Birthday = '1900-01-01';
            this.resumeInfo.basic_info.MarriedStatusID = Number(this.resumeInfo.basic_info.MarriedStatusID);
            this.resumeInfo.expect_jobnature.JobNatureID = Number(this.resumeInfo.expect_jobnature.JobNatureID);
            this.resumeInfo.basic_info.WorkYear = Number(this.resumeInfo.basic_info.WorkYear);
            this.resumeInfo.basic_info.DegreeID = 0;
            addResume({
              resumeInfo: this.resumeInfo
            }).then(m => {
              if (m.errcode == 0) {
                this.$message.success('简历添加成功');
                this.$emit('complete', m.data);
              } else {
                this.$message.error('简历添加失败，原因：' + m.errmsg);
                this.$emit('complete', 0);
              }
            }).catch(() => {
              this.$emit('complete', 0);
            });
          } else {
            this.$emit('complete', 0);
          }
        });

      },
      onSexChange(value) {
        let sexId = Number(value);
        if (sexId > 0) {
          this.resumeInfo.basic_info.SexID = sexId;
          this.resumeInfo.user_infokey.Sex = sexId;
        } else {
          this.resumeInfo.basic_info.SexID = '';
          this.resumeInfo.user_infokey.Sex = '';
        }
      },
      getBirtday(value) {
        var date = new Date(value);
        if (date && date.getFullYear() > 1900) {
          this.resumeInfo.basic_info.Birthday = value;
        } else {
          this.resumeInfo.basic_info.Birthday = '';
        }
      },
      onLiveCityIDChange(value) {
        this.resumeInfo.basic_info.LiveCityID = value;
      },
      onPositionChange(value) {
        this.exceptPositionIDs = value;
        this.resumeInfo.expect_post = [];
        if (value != null && value.length > 0) {
          value.forEach(el => {
            this.resumeInfo.expect_post.push({
              PositionID: el
            });
          });
        }
      },
      onExpectCityIDChange(value) {
        this.resumeInfo.expect_city.CityID = Number(value);
      },

      uploadPhoto(file) {
        const isImage = (file.type === 'image/jpeg' || file.type === 'image/png');
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isImage) {
          this.$message.error('只能上传图片格式（jpg 或者 png）');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB');
        }
        if (!isImage || !isLt2M) return;

        var formData = new FormData();
        formData.append('name', file.name);
        formData.append('file', file);
        uploadPhoto(formData).then(m => {
          if (m.errcode == 0) {
            this.resumeInfo.user_data.Logo = m.data.img;
          }
        });
      },

      //工作经历 删除----------------------------
      workExpDel(index) {
        this.$confirm('确认删除该段工作经历?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.resumeInfo.work_exp.splice(index, 1);
          })
          .catch(() => {
            // console.log("取消");
          });
      },

      workExpEdit(work_item, index) {
        var workInfo = {
          company_name: work_item.CompanyName,
          company_size_id: work_item.CoSizeID == 0 ? '' : work_item.CoSizeID,
          company_type_id: work_item.CoEconomyID == 0 ? '' : work_item.CoEconomyID,
          department: work_item.WorkDepartment,
          description: work_item.Description,
          end_date: this.$Shared.formatDateYearMonth(work_item.EndDate),
          exp_id: index,
          industry_id: work_item.IndustryID == 0 ? '' : work_item.IndustryID,
          position: work_item.WorkPosition,
          resume_id: 0,
          start_date: this.$Shared.formatDateYearMonth(work_item.BeginDate)
        };
        this.work_item = workInfo;
        this.editWork = true;
      },
      workEditChange(data) {
        let index = data.Index;
        Vue.set(this.resumeInfo.work_exp, index, data);
      },
      workAdd() {
        this.$refs.workAdd.add();
      },
      workAddChange(data) {
        this.resumeInfo.work_exp.unshift(data);
      },

      //教育经历：删除----------------------------------------
      eduExpDel(index) {
        this.$confirm('确认删除该段教育经历?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.resumeInfo.edu_exp.splice(index, 1);
          });
      },
      eduExpEdit(item, index) {
        var eduInfo = {
          start_date: this.$Shared.formatDateYearMonth(item.BeginDate),
          end_date: this.$Shared.formatDateYearMonth(item.EndDate),
          school_name: item.School,
          degree_id: item.DegreeID == 0 ? '' : item.DegreeID,
          major: item.Major,
          edu_mode_id: item.EduModeID == 0 ? '' : item.EduModeID,
          exp_id: index
        };
        this.edu_item = eduInfo;
        this.editEdu = true;
      },
      eduEditChange(data) {
        let index = data.Index;
        Vue.set(this.resumeInfo.edu_exp, index, data);
      },
      eduAdd() {
        this.$refs.eduAdd.add();
      },
      eduAddChange(data) {
        this.resumeInfo.edu_exp.unshift(data);
      },

      //项目经历：删除--------------------------------------
      proExpDel(index) {
        this.$confirm('确认删除该段项目经历?', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        })
          .then(() => {
            this.resumeInfo.project_exp.splice(index, 1);
          });
      },
      //项目经历：添加 与 删除---------------------------------
      _GetProExp(data) {
        return {
          Index: data.exp_id,
          ProjectName: data.project_name, //	nvarchar(255)	项目名称
          BeginDate: data.start_date, //	date	开始时间
          EndDate: data.end_date, //	date	结束时间
          CompanyName: data.company, //	nvarchar(255)	所属公司
          Description: data.description //	nvarchar(MAX)	项目描述
        };
      },
      _SetProExpEdit(pro) {
        return {
          exp_id: pro.Index,
          project_name: pro.ProjectName, //	nvarchar(255)	项目名称
          start_date: this.$Shared.formatDateYearMonth(pro.BeginDate), //	date	开始时间
          end_date: this.$Shared.formatDateYearMonth(pro.EndDate), //	date	结束时间
          company: pro.CompanyName, //	nvarchar(255)	所属公司
          description: pro.Description //	nvarchar(MAX)	项目描述
        };
      },
      proExpEdit(item, index) {
        var projectInfo = this._SetProExpEdit(item);
        projectInfo.exp_id = index;
        this.project_item = projectInfo;
        this.editProject = true;
      },
      projectEditChange(data) {
        let index = data.exp_id;
        Vue.set(this.resumeInfo.project_exp, index, this._GetProExp(data));
      },
      projectAdd() {
        this.$refs.projectAdd.add();
      },
      projectAddChange(data) {
        this.resumeInfo.project_exp.unshift(this._GetProExp(data));
      },
      onMonthSalaryChange(salarys) {
        this.resumeInfo.expect_salary.MinSalary = salarys[0];
        this.resumeInfo.expect_salary.MaxSalary = salarys[1];
      },
      onYearSalaryChange(salarys) {
        this.resumeInfo.expect_salary.MinYearSalary = salarys[0];
        this.resumeInfo.expect_salary.MaxYearSalary = salarys[1];
      },
      onDeleteHeadImage(event) {
        this.resumeInfo.user_data.Logo = '';
        event.stopPropagation();
      },
      eduAddVisibleChange(val) {
        this.addEdu = val;
      },
      onEduAdd(data) {
        if (data) {
          var eduInfo = {
            BeginDate: data.start_date,
            EndDate: data.end_date,
            School: data.school_name,
            DegreeID: data.degree_id,
            Major: data.major,
            EduModeID: data.edu_mode_id
          };
          this.resumeInfo.edu_exp.unshift(eduInfo);
        }
      },
      eduEditVisibleChange(val) {
        this.editEdu = val;
      },
      onEduEdit(data) {
        this.edu_item = {};
        if (data) {
          var eduInfo = this.resumeInfo.edu_exp[data.exp_id];
          if (eduInfo) {
            eduInfo.BeginDate = data.start_date;
            eduInfo.EndDate = data.end_date;
            eduInfo.School = data.school_name;
            eduInfo.DegreeID = data.degree_id;
            eduInfo.Major = data.major;
            eduInfo.EduModeID = data.edu_mode_id;
          }
        }
      },
      workAddVisibleChange(val) {
        this.addWork = val;
      },
      onWorkAdd(data) {
        if (data) {
          var workInfo = {
            BeginDate: data.start_date,
            EndDate: data.end_date,
            CompanyName: data.company_name,
            WorkPosition: data.position,
            WorkDepartment: data.department,
            Description: data.description,
            CoSizeID: data.company_size_id,
            CoEconomyID: data.company_type_id,
            IndustryID: data.industry_id,
          };
          this.resumeInfo.work_exp.unshift(workInfo);
        }
      },
      workEditVisibleChange(val) {
        this.editWork = val;
      },
      onWorkEdit(data) {
        this.work_item = {};
        if (data) {
          var workInfo = this.resumeInfo.work_exp[data.exp_id];
          if (workInfo) {
            workInfo.BeginDate = data.start_date;
            workInfo.EndDate = data.end_date;
            workInfo.CompanyName = data.company_name;
            workInfo.WorkPosition = data.position;
            workInfo.WorkDepartment = data.department;
            workInfo.Description = data.description;
            workInfo.CoSizeID = data.company_size_id;
            workInfo.CoEconomyID = data.company_type_id;
            workInfo.IndustryID = data.industry_id;
          }
        }
      },
      projectAddVisibleChange(val) {
        this.addProject = val;
      },
      onProjectAdd(data) {
        if (data) {
          var projectInfo = this._GetProExp(data);
          this.resumeInfo.project_exp.unshift(projectInfo);
        }
      },
      projectEditVisibleChange(val) {
        this.editProject = val;
      },
      onProjectEdit(data) {
        this.project_item = {};
        if (data) {
          var projectInfo = this.resumeInfo.project_exp[data.exp_id];
          if (projectInfo) {
            projectInfo.ProjectName = data.project_name,
            projectInfo.BeginDate = data.start_date,
            projectInfo.EndDate = data.end_date,
            projectInfo.CompanyName = data.company,
            projectInfo.Description = data.description;
          }
        }
      },
      certificateVisibleChange(val) {
        this.editCertificate = val;
      },
      certificateChange(data) {
        this.editCertificateList = [];
        if (data) {
          this.resumeInfo.MeResumeCertificateList = [];
          data.forEach(item => {
            this.resumeInfo.MeResumeCertificateList.push({
              CertificateName: item.name
            });
          });
        }
      },
      languageSkillVisibleChange(val) {
        this.editLanguageSkill = val;
      },
      languageSkillChange(data) {
        this.editLanguageSkillList = [];
        if (data) {
          this.resumeInfo.MeResumeLanguageSkillList = [];
          data.forEach(item => {
            this.resumeInfo.MeResumeLanguageSkillList.push({
              LanguageSkillName: item.name,
              SkillLevel: item.level
            });
          });
        }
      },
      professionalSkillVisibleChange(val) {
        this.editProfessionalSkill = val;
      },

      professionalSkillChange(data) {
        this.editProfessionalSkillList = [];
        if (data) {
          this.resumeInfo.MeResumeProfessionalSkillList = [];
          data.forEach(item => {
            this.resumeInfo.MeResumeProfessionalSkillList.push({
              ProfessionalSkillName: item.name,
              SkillLevel: item.level,
              SkillLevelID: item.level_id
            });
          });
        }
      },


      onNativeCityChange(val) {
        var cityId = 0;
        if (val && Array.isArray(val)) {
          cityId = val[val.length - 1];
        }

        let number = Number(cityId);
        this.resumeInfo.basic_info.NativeCityID = number > 0 ? cityId : '';
      },

      onLiveCityChange(val) {
        var cityId = 0;
        if (val && Array.isArray(val)) {
          cityId = val[val.length - 1];
        }
        let number = Number(cityId);
        this.resumeInfo.basic_info.LiveCityID = number > 0 ? cityId : '';
      },

      getMobileVerifyCode() {
        this.newMobile = this.newMobile.trim();
        if (!this.$Shared.isMobile(this.newMobile)) {
          this.$message.error('请输入正确的手机号码');
          return false;
        }
        if (this.newMobile === this.resumeInfo.user_data.Mobile) {
          this.$message.error('新手机和原手机相同，无需修改');
          return false;
        }
        var params = {
          mobile: this.newMobile
        };
        getMobileVerifyCode(params).then(m => {
          if (m.errcode === 0) {
            this.mobileVerifyVisible = true;
            this.mobileVerifyCode = '';
            this.mobileTime = 60;
            this.mobileTimer();
          } else {
            this.$message.error('获取验证码失败，失败原因：' + m.errmsg);
          }
        });
      },
      mobileTimer() {
        if (this.mobileTime > 0) {
          this.mobileTime--;
          setTimeout(this.mobileTimer, 1000);
        } else {
          this.mobileTime = 0;
        }
      },
      onChangeMobile() {
        this.newMobile = this.newMobile.trim();
        if (!this.$Shared.isMobile(this.newMobile)) {
          this.$message.error('请输入正确的手机号码');
          return false;
        }
        if (!this.mobileVerifyCode) {
          this.$message.error('请输入验证码');
          return false;
        }
        var params = {
          mobile: this.newMobile,
          captcha: this.mobileVerifyCode
        };
        changeMobile(params).then(m => {
          if (m.errcode === 0) {
            this.$message.success('手机修改成功');
            this.resumeInfo.user_data.Mobile = this.newMobile;
            this.mobileVerifyVisible = false;
          } else {
            this.$message.error('手机修改失败，失败原因：' + m.errmsg);
          }
        });
      },

      getEmailVerifyCode() {
        if (!this.$Shared.isEmail(this.resumeInfo.user_data.Email)) {
          this.$message.error('请输入正确的电子邮箱');
          return false;
        }
        var params = {
          email: this.resumeInfo.user_data.Email
        };
        getEmailVerifyCode(params).then(m => {
          if (m.errcode === 0) {
            this.emailVerifyVisible = true;
            this.emailVerifyCode = '';
            this.emailTime = 60;
            this.emailTimer();
          } else {
            this.$message.error('获取验证码失败，失败原因：' + m.errmsg);
          }
        });
      },
      onChangeEmail() {
        if (!this.$Shared.isEmail(this.resumeInfo.user_data.Email)) {
          this.$message.error('请输入正确的电子邮箱');
          return false;
        }
        if (!this.emailVerifyCode) {
          this.$message.error('请输入验证码');
          return false;
        }
        var params = {
          email: this.resumeInfo.user_data.Email,
          captcha: this.emailVerifyCode
        };
        changeEmail(params).then(m => {
          if (m.errcode === 0) {
            this.$message.success('邮箱修改成功');
            this.emailVerifyVisible = false;
          } else {
            this.$message.error('邮箱修改失败，失败原因：' + m.errmsg);
          }
        });
      },
      emailTimer() {
        if (this.emailTime > 0) {
          this.emailTime--;
          setTimeout(this.emailTimer, 1000);
        } else {
          this.emailTime = 0;
        }
      },
      onEditProfessionalSkill() {
        this.editProfessionalSkill = true;
        this.editProfessionalSkillList = [];
        this.resumeInfo.MeResumeProfessionalSkillList.forEach(p => {
          this.editProfessionalSkillList.push({
            name: p.ProfessionalSkillName,
            level: p.SkillLevel,
            level_id: p.SkillLevelID
          });
        });
      },
      onEditCertificate() {
        this.editCertificate = true;
        this.editCertificateList = [];
        this.resumeInfo.MeResumeCertificateList.forEach(c => {
          this.editCertificateList.push({
            name: c.CertificateName
          });
        });
      },
      onEditLanguageSkill() {
        this.editLanguageSkill = true;
        this.editLanguageSkillList = [];
        this.resumeInfo.MeResumeLanguageSkillList.forEach(l => {
          this.editLanguageSkillList.push({
            name: l.LanguageSkillName,
            level: l.SkillLevel
          });
        });
      },
    }
  };
</script>

<style lang="scss" scoped>
  h3 {
    line-height: 28px;
  }

  .section1 {
    margin-bottom: 20px;
  }

  .moreinfo {
    text-align: center;
    font-size: 12px;
    color: #1896ff;
    cursor: pointer;
  }

  .section {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 3px;
    // line-height: 1.5;
  }

  .section-row {
    margin-bottom: 5px;
    line-height: 1.8;
  }

  .section-text p,
  .section-text .el-row {
    line-height: 1.5;
  }

  .section-text p {
    margin-top: 0;
  }

  .section ul li {
    position: relative;
    padding-bottom: 30px;
    padding-right: 15px;
  }

  .shadow-useravatar-big {
    width: 120px;
    height: 120px;
  }

  .useravatar-shadow-container {
    margin: 0;
    width: 120px;
    height: 120px;
  }

  .imgcenter {
    text-align: center;
    padding-bottom: 41px;
  }

  .el-input-group__append,
  .el-input-group__append .el-button {
    width: 60px;
  }

  .el-divider--horizontal {
    margin: 0 0 20px 0;
  }
</style>